import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, PlusCircle, Layers } from "lucide-react";
import { DynIcon } from "@/components/site/DynIcon";
import { T } from "@/context/LanguageContext";

export function ModuleCard({ geoId, module }) {
  const inherited = module.visibility_state === "inherited" && module.inherited_from;
  // Inherited content links to the parent (county/state) article it is served from.
  const to = inherited
    ? `/learn/${module.inherited_from.geo_id}/${module.key}`
    : `/learn/${geoId}/${module.key}`;
  return (
    <div
      className="group flex flex-col rounded-xl border border-border bg-white p-4 transition-all hover:border-navy/30 hover:shadow-sm"
      data-testid={`module-${module.key}`}
    >
      <div className="mb-2 flex items-center gap-2">
        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-navy/5 text-oldglory-red">
          <DynIcon name={module.icon} className="h-4 w-4" />
        </span>
        <h4 className="font-display text-base font-bold text-navy"><T>{module.label}</T></h4>
      </div>
      {inherited && (
        <div
          className="mb-2 inline-flex w-fit items-center gap-1.5 rounded-full bg-amber-50 px-2.5 py-1 text-[10px] font-semibold text-amber-800 ring-1 ring-amber-500/30"
          data-testid={`module-inherited-${module.key}`}
          title="Regional content shown because local content isn't available yet"
        >
          <Layers className="h-3 w-3" />
          <T>Serving</T> {module.scope_label} · <T>from</T> {module.inherited_from.name}
        </div>
      )}
      {module.snippet ? (
        <p className="mb-3 line-clamp-3 text-sm leading-relaxed text-ink/75"><T>{module.snippet}</T></p>
      ) : (
        <p className="mb-3 flex items-center gap-1.5 text-sm text-muted-foreground">
          <PlusCircle className="h-3.5 w-3.5 text-oldglory-red/70" />
          <T>Being built — open to read an overview and add what you know.</T>
        </p>
      )}
      <Link
        to={to}
        className="mt-auto inline-flex items-center gap-1.5 text-sm font-semibold text-oldglory-red transition-colors hover:text-oldglory-dark"
        data-testid={`module-open-${module.key}`}
      >
        <T>{module.snippet ? "Read full article" : "Explore & contribute"}</T>
        <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
      </Link>
    </div>
  );
}
